export default __webpack_public_path__ + "static/media/barcode-sample.0b366e16.png";